<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title20"></a>
<div class="toc_entry"><a class="toc_entry_frontMatter" href="#/9781459252165_fm01"><span><strong class="b">“Tell me one good reason. why you and I can’t continue to be lovers.”</strong></span></a><br/>
<a class="toc_entry_frontMatter" href="#/9781459252165_fm02"><span><strong class="b">She’s sexy, successful... and PREGNANT!</strong></span></a><br/>
<a class="toc_entry_titlePage" href="#/9781459252165_tp01"><span>Title Page</span></a><br/>
<a class="toc_entry_chapter" href="#/9781459252165_c01"><span><strong class="b">CHAPTER ONE</strong></span></a><br/>
<a class="toc_entry_chapter" href="#/9781459252165_c02"><span><strong class="b">CHAPTER TWO</strong></span></a><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c03" title="Link target outside of Sample"><span><strong class="b">CHAPTER THREE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c04" title="Link target outside of Sample"><span><strong class="b">CHAPTER FOUR</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c05" title="Link target outside of Sample"><span><strong class="b">CHAPTER FIVE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c06" title="Link target outside of Sample"><span><strong class="b">CHAPTER SIX</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c07" title="Link target outside of Sample"><span><strong class="b">CHAPTER SEVEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c08" title="Link target outside of Sample"><span><strong class="b">CHAPTER EIGHT</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c09" title="Link target outside of Sample"><span><strong class="b">CHAPTER NINE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c10" title="Link target outside of Sample"><span><strong class="b">CHAPTER TEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c11" title="Link target outside of Sample"><span><strong class="b">CHAPTER ELEVEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c12" title="Link target outside of Sample"><span><strong class="b">CHAPTER TWELVE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c13" title="Link target outside of Sample"><span><strong class="b">CHAPTER THIRTEEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c14" title="Link target outside of Sample"><span><strong class="b">CHAPTER FOURTEEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c15" title="Link target outside of Sample"><span><strong class="b">CHAPTER FIFTEEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c16" title="Link target outside of Sample"><span><strong class="b">CHAPTER SIXTEEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459252165_c17" title="Link target outside of Sample"><span><strong class="b">CHAPTER SEVENTEEN</strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/9781459252165_cop01" title="Link target outside of Sample"><span>Copyright</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459252165_toc01.vue?90f87440